var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 14.7865H13.125V13.5365H6.875V14.7865ZM6.875 11.4531H13.125V10.2031H6.875V11.4531ZM5.25646 17.9115C4.83549 17.9115 4.47917 17.7656 4.1875 17.474C3.89583 17.1823 3.75 16.826 3.75 16.405V3.58458C3.75 3.16361 3.89583 2.80729 4.1875 2.51563C4.47917 2.22396 4.83549 2.07812 5.25646 2.07812H11.875L16.25 6.45313V16.405C16.25 16.826 16.1042 17.1823 15.8125 17.474C15.5208 17.7656 15.1645 17.9115 14.7435 17.9115H5.25646ZM11.25 7.07813V3.32813H5.25646C5.19229 3.32813 5.13354 3.35486 5.08021 3.40833C5.02674 3.46167 5 3.52042 5 3.58458V16.405C5 16.4692 5.02674 16.5279 5.08021 16.5813C5.13354 16.6347 5.19229 16.6615 5.25646 16.6615H14.7435C14.8077 16.6615 14.8665 16.6347 14.9198 16.5813C14.9733 16.5279 15 16.4692 15 16.405V7.07813H11.25Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHour);
export default __webpack_public_path__ + "static/media/hour.efe9b5a32b14488c61835881cc0a1457.svg";
export { ForwardRef as ReactComponent };